<template>
  <div class="addresolution">
    <van-cell-group>
      <van-field
        v-model="width"
        type="number"
        label="宽度"
        placeholder="请输入宽度"
        required
        @blur="requiredW"
        :error-message="errorW"
      />
      <van-field
        v-model="height"
        required
        type="number"
        label="高度"
        placeholder="请输入高度"
        @blur="requiredH"
        :error-message="errorH"
      />
    </van-cell-group>
    <div style="height: 30px"></div>
    <van-button block size="small" type="info" @click="onsubmit">添加</van-button>
  </div>
</template>

<script>
  import qs from 'qs'
  import { Toast } from 'vant'
  import $ from 'jquery'

  export default {
    name: 'addresolution',
    data() {
      return {
        height: '',
        width: '',
        errorH: '',
        errorW: '',
      }
    },
    mounted() {
      this.$nextTick(()=>{
        var winHeight = $(window).height()
        $(window).resize(function ()  {
          var thisWidth = $(this).height()
          if (winHeight > thisWidth) {
            $(".nut-tabbar").hide()
          }else {
            $(".nut-tabbar").show()
          }
        })
      })
    },
    methods: {
      onsubmit() {
        if (!this.width || !this.height) {
          Toast('高度/宽度不能为空')
          return
        }
        this.$ajax.post('/etv/insertResolution.json', qs.stringify({
          ruLPixel: this.width,
          ruWPixel: this.height,
        })).then(res => {
          if (res.data.code === 0) {
            Toast('添加成功')
            this.$router.push('/newprogram')
          } else {
            Toast(res.data.msg)
          }
        })
      },
      requiredW() {
        if (this.width === '' || parseInt(this.width) <= 299 || parseInt(this.width) >= 8001) {
          this.errorW = '请输入300~8000之间数'
        } else {
          this.errorW = ''
        }
      },
      requiredH() {
        if (parseInt(this.height) <= 299 || parseInt(this.height) >= 8001) {
          this.errorH = '请输入300~8000之间数'
        } else {
          this.errorH = ''
        }
      },
    },
  }
</script>

<style scoped>
  .addresolution {
    padding: 10px;
    box-sizing: border-box;
  }
</style>
